import React, { useState, useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import {
  RadioButtonCheckedRounded,
  RadioButtonUncheckedRounded,
} from '@material-ui/icons';
import { Button, Tooltip } from '@material-ui/core';
import { FaUndo } from "react-icons/fa";

const DeselectableRadioGroup = ({
  classes,
  ariaLabel,
  name,
  options,
  value,
  onChange,
  title,
  titleClass, 
  refreshDisabled,
  refreshOnClick,
  disabled,
}) => {
  let initialSelectedValue = "";

  if (value === 1) {
    initialSelectedValue = true;
  } else if (value === 0) {
    initialSelectedValue = false;
  } else {
    initialSelectedValue = value;
  }

  const [selectedValue, setSelectedValue] = useState(initialSelectedValue);

  useEffect(() => {
    if (initialSelectedValue === undefined || initialSelectedValue === null) {
      setSelectedValue(null);
    } else {
      setSelectedValue(initialSelectedValue);
    }
  }, [initialSelectedValue]);

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
    onChange({ target: { name, value: newValue } });
  };

  return (
    <>
    <div class="singleBlock">


      <label className={classes.globalCreateLabel} htmlFor={title}>
        {title}
      </label>
      <span> :</span>
      <div>
        <ToggleButtonGroup
          color="primary"
          value={selectedValue}
          exclusive
          onChange={handleChange}
          aria-label={ariaLabel}>
          {options.map((option) => (
            <ToggleButton
              key={option.value}
              value={option.value}
              disabled={disabled}
              aria-label={option.label}>
              {selectedValue === option.value ? (
                <RadioButtonCheckedRounded disabled={disabled} />
              ) : (
                <RadioButtonUncheckedRounded disabled={disabled} />
              )}
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        {!refreshDisabled && (
          <Tooltip title={"Reset to default value"}>
            <Button
              aria-label={name}
              id={name}
              name={name}
              disabled={refreshDisabled}
              onClick={refreshOnClick}
              className={classes.resetButton}>
              <FaUndo style={{ fontSize: "10px" }} />
            </Button>
          </Tooltip>
        )}
      </div>
          </div>
    </>
  );
};

export default DeselectableRadioGroup;
